import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonPubstringToArray'
})
export class JsonPubstringToArrayPipe implements PipeTransform {

  transform(value: string): any[] | undefined {
    if (value) {
      value = value.trim();
      try {

        let jsonValue = JSON.parse(value);
        const uniqueValues: any[] = [];
        const uniquePubTypes: Set<string> = new Set();

        jsonValue.forEach((item:any) => {
          if (!uniquePubTypes.has(item.PubType)) {
            uniqueValues.push(item);
            uniquePubTypes.add(item.PubType);
          }
        });

        return uniqueValues;
      } catch (error) {
        console.error('Invalid JSON string:', error);
        return [];
      }
    }

  }

}
